import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Paper,
  Button,
  TextField,
  MenuItem,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import getNameByID from "../../../../functions/getNameByID";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import SearchSetInvoices from "../../../components/Search/SearchSetInvoices";
import { Get_Invoices_Fuzzy_Search } from "../../Xero/api/Get_Invoices_Fuzzy_Search";
import { Get_All_From_Array_Of_Object_IDs_From_MongoDB } from "../../../api/Get_All_From_Array_Of_Object_IDs_From_MongoDB";
import { Send_Invoice_Reminder_Email } from "../api/Send_Invoice_Reminder_Email";
// material-ui

function InvoiceReminders() {
  const { logout } = StaffuseAuth();

  const [Arr_UnPaidInvoices, setArr_UnPaidInvoices] = useState([]);
  //get all unpaid invoices
  useEffect(() => {
    Get_Invoices_Fuzzy_Search(
      "Invoices",
      "Xero_2025",
      {
        InvoiceNumber: "",
        Staff_id: "",
        Paid_Status: "UnPaid",
        DueAfter: "",
        DueBefore: "",
      },
      Number(10000),
      setArr_UnPaidInvoices,
      { Due_Date: 1 },
      {},
      logout
    );
  }, []);

  function handleSend(Invoice, e) {
    e.preventDefault();
    Send_Invoice_Reminder_Email(
      Invoice,
      localStorage.getItem("_id"),
      determineDueEmailFiltered(Invoice),
      logout
    );
  }

  function handleSendAll(e) {
    e.preventDefault();
    Arr_InvoicesNeed.forEach((Invoice) => {
      Send_Invoice_Reminder_Email(
        Invoice,
        localStorage.getItem("_id"),
        determineDueEmailFiltered(Invoice),
        logout
      );
    });
  }

  const [View, setView] = useState("All");

  function handleViewChangeAll(e) {
    e.preventDefault();
    setView("All");
  }

  function handleViewChangeNeed(e) {
    e.preventDefault();
    setView("Need");
  }

  //------------------------------Get Emails Due---------------------------------//

  //get the days until the due date
  function DaysUntilDue(DueDate) {
    const now = new Date();
    const due = new Date(DueDate);
    const diffTime = due - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  //email sequence
  const emailSequence = [
    "2-week Email Sent",
    "1-week Email Sent",
    "24-hour Email Sent",
    "Overdue Email Sent",
  ];

  //determine the next email to send, assuming a Due Date is present, regardless of what has already been sent
  const determineDueEmail = (Invoice) => {
    if (Invoice.Due_Date && Invoice.Due_Date !== "") {
      let Days = DaysUntilDue(Invoice.Due_Date);
      if (Days > 14) {
        return null;
      } else if (Days > 7) {
        return emailSequence[0];
      } else if (Days > 1) {
        return emailSequence[1];
      } else if (Days > -1) {
        return emailSequence[2];
      } else if (Days > -10 && Days < 0) {
        return emailSequence[3];
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  //determine the next email to send, assuming a Due Date is present, and filter out emails that have already been sent. This is what i use in the table
  const determineDueEmailFiltered = (Invoice) => {
    let NextEmail = determineDueEmail(Invoice);

    const notes = Invoice.Notes || []; // Default to an empty array if Notes is undefined

    // Filter notes to include only email-related notes
    const emailNotes = notes.filter((note) =>
      emailSequence.includes(note.Note)
    );
    if (emailNotes.length === 0) {
      return NextEmail;
    }
    //see if the array emailNotes contains an object woth the value of NextEmail in the Note field
    if (emailNotes.some((note) => note.Note === NextEmail)) {
      return null;
    } else {
      return NextEmail;
    }
  };

  const Arr_InvoicesNeed = Arr_UnPaidInvoices.filter((Invoice) =>
    //determineDueEmailFiltered(Invoice) ? true : false
    determineDueEmailFiltered(Invoice) &&
    Invoice.Attendees.map((Attendee) => {
      return Attendee.Attendee_id;
    }) &&
    Invoice.Attendees.map((Attendee) => {
      return Attendee.Attendee_id;
    }).length > 0
      ? true
      : false
  );

  let Arr_data;
  if (View === "Need") {
    Arr_data = Arr_InvoicesNeed;
  } else {
    Arr_data = Arr_UnPaidInvoices;
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Emails</h1>
        <h2>Invoice Reminders</h2>
        <DisplayExport
          excelData={Arr_UnPaidInvoices}
          fileName="Arr_UnPaidInvoices"
        />
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            maxWidth: "5%",
            maxHeight: "100px",
            Height: "100px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <button onClick={(e) => handleSendAll(e)}>Send ALL</button>{" "}
          <button onClick={(e) => handleViewChangeAll(e)}>View All</button>{" "}
          <button onClick={(e) => handleViewChangeNeed(e)}>View Need</button>{" "}
        </Box>

        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {SimpleTableHeader("ID")}
                  {SimpleTableHeader("Invoice Number")}
                  {SimpleTableHeader("Paid_Status")}
                  {SimpleTableHeader("DueDate")}
                  {SimpleTableHeader("Days Until Due")}
                  {SimpleTableHeader("Next Email Filtered")}
                  {SimpleTableHeader("Attendees")}
                </TableRow>
              </TableHead>
              <TableBody>
                {Arr_data && Array.isArray(Arr_data) ? (
                  Arr_data.map((Obj_UnPaidInvoice, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                          "& .MuiTableCell-root": {
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word", // Adjust padding here to make cells smaller
                          },
                        },
                        backgroundColor: "inherit",
                      }}
                    >
                      {SimpleTableCell(Obj_UnPaidInvoice._id)}
                      {SimpleTableCell(Obj_UnPaidInvoice.Invoice_Number)}
                      {SimpleTableCell(Obj_UnPaidInvoice.Paid_Status)}
                      {SimpleTableCell(Obj_UnPaidInvoice.Due_Date)}
                      {SimpleTableCell(
                        DaysUntilDue(Obj_UnPaidInvoice.Due_Date)
                      )}
                      {SimpleTableCell(
                        determineDueEmailFiltered(Obj_UnPaidInvoice)
                      )}
                      {SimpleTableCell(
                        determineDueEmailFiltered(Obj_UnPaidInvoice)
                          ? //display all attendees id's
                            Obj_UnPaidInvoice.Attendees.map((Attendee) => {
                              return Attendee.Attendee_id;
                            }).join(", ")
                          : ""
                      )}
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {determineDueEmailFiltered(Obj_UnPaidInvoice) &&
                        Obj_UnPaidInvoice.Attendees.map((Attendee) => {
                          return Attendee.Attendee_id;
                        }) &&
                        Obj_UnPaidInvoice.Attendees.map((Attendee) => {
                          return Attendee.Attendee_id;
                        }).length > 0 ? (
                          <button
                            onClick={(e) => handleSend(Obj_UnPaidInvoice, e)}
                          >
                            Send
                          </button>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default InvoiceReminders;
